import React from 'react';
import { isNil } from 'lodash';
import Anchor from '../Anchor';
import { setDetailPageUrl } from '../../../lib/common';
import { ORDER_RETURN_DETAIL_URL_PATH } from '../../../constants/service/common/urlConstants';

const OpenOrderReturnItemDetail = (props) => {
  const { text, orderItemId } = props;

  /**
   * 링크로 연결할 데이터가 없다면
   * '-' 를 반환함
   */
  if (isNil(text) && isNil(orderItemId)) {
    return '-';
  }

  return (
    <Anchor
      isUnderLine
      color="primary"
      text={text}
      href={setDetailPageUrl(ORDER_RETURN_DETAIL_URL_PATH, orderItemId)}
      target="_blank"
    />
  );
};

export default OpenOrderReturnItemDetail;
